import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetMaterialPriceWriteCapabilityQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMaterialPriceWriteCapabilityQuery = { __typename?: 'Query', materialPriceWriteCapability: { __typename?: 'MaterialPriceWriteCapabilityPayload', disabledReason?: string | null, enabled: boolean, flagEnabled: boolean, flagResolutionReason: Types.FeatureFlagResolutionReason, identityReadinessReason?: string | null, materialPriceIdentityReadReady: boolean } };

export type MaterialPriceQuoteFragment = { __typename?: 'MaterialPriceQuoteData', effectiveDate?: string | null, isBaseRate: boolean, priceId: string, revision: number, royaltyCoverage: Types.RoyaltyCoverage, status: Types.MaterialPriceStatus, supplierRoyaltyPerEachText?: string | null, supplierRoyaltyStatus: Types.SupplierRoyaltyStatus, unitCostText: string };

export type MaterialApplicablePriceFragment = { __typename?: 'MaterialApplicablePriceData', earliestFutureEffectiveDate?: string | null, state: Types.ApplicablePriceState, quote?: { __typename?: 'MaterialPriceQuoteData', effectiveDate?: string | null, isBaseRate: boolean, priceId: string, revision: number, royaltyCoverage: Types.RoyaltyCoverage, status: Types.MaterialPriceStatus, supplierRoyaltyPerEachText?: string | null, supplierRoyaltyStatus: Types.SupplierRoyaltyStatus, unitCostText: string } | null };

export type GetMaterialPriceActionPreviewQueryVariables = Types.Exact<{
  input: Types.MaterialPriceActionPreviewInput;
}>;


export type GetMaterialPriceActionPreviewQuery = { __typename?: 'Query', materialPriceActionPreview: { __typename?: 'MaterialPriceActionPreviewPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, preview?: { __typename?: 'MaterialPriceActionPreview', action: Types.MaterialPriceAction, asOf: string, estimateEffect: Types.MaterialPriceEstimateEffect, explanation: string, isDefaultVendor: boolean, purchasingRevision: number, vendorId: string, current: { __typename?: 'MaterialApplicablePriceData', earliestFutureEffectiveDate?: string | null, state: Types.ApplicablePriceState, quote?: { __typename?: 'MaterialPriceQuoteData', effectiveDate?: string | null, isBaseRate: boolean, priceId: string, revision: number, royaltyCoverage: Types.RoyaltyCoverage, status: Types.MaterialPriceStatus, supplierRoyaltyPerEachText?: string | null, supplierRoyaltyStatus: Types.SupplierRoyaltyStatus, unitCostText: string } | null }, proposed: { __typename?: 'MaterialPriceQuoteData', effectiveDate?: string | null, isBaseRate: boolean, priceId: string, revision: number, royaltyCoverage: Types.RoyaltyCoverage, status: Types.MaterialPriceStatus, supplierRoyaltyPerEachText?: string | null, supplierRoyaltyStatus: Types.SupplierRoyaltyStatus, unitCostText: string }, resulting: { __typename?: 'MaterialApplicablePriceData', earliestFutureEffectiveDate?: string | null, state: Types.ApplicablePriceState, quote?: { __typename?: 'MaterialPriceQuoteData', effectiveDate?: string | null, isBaseRate: boolean, priceId: string, revision: number, royaltyCoverage: Types.RoyaltyCoverage, status: Types.MaterialPriceStatus, supplierRoyaltyPerEachText?: string | null, supplierRoyaltyStatus: Types.SupplierRoyaltyStatus, unitCostText: string } | null }, selected: { __typename?: 'MaterialPriceQuoteData', effectiveDate?: string | null, isBaseRate: boolean, priceId: string, revision: number, royaltyCoverage: Types.RoyaltyCoverage, status: Types.MaterialPriceStatus, supplierRoyaltyPerEachText?: string | null, supplierRoyaltyStatus: Types.SupplierRoyaltyStatus, unitCostText: string } } | null } };

export type GetMaterialPriceHistoryQueryVariables = Types.Exact<{
  materialItemId: Types.Scalars['String']['input'];
  priceId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  vendorId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMaterialPriceHistoryQuery = { __typename?: 'Query', materialPriceHistory: Array<{ __typename?: 'MaterialPriceHistoryRecord', action: Types.MaterialPriceHistoryAction, actor?: string | null, diagnostic?: string | null, eventId: string, eventNumber: number, occurredAt: Types.TDateISO, priceId: string, reason?: string | null, revision: number, status: Types.MaterialPriceStatus, vendorDetached: boolean, vendorId: string, after?: { __typename?: 'MaterialPriceHistoryValues', effectiveDate?: Types.TDateISO | null, isBaseRate: boolean, status: Types.MaterialPriceStatus, supplierRoyaltyPerEachText?: string | null, supplierRoyaltyStatus: Types.SupplierRoyaltyStatus, unitCostText: string } | null, before?: { __typename?: 'MaterialPriceHistoryValues', effectiveDate?: Types.TDateISO | null, isBaseRate: boolean, status: Types.MaterialPriceStatus, supplierRoyaltyPerEachText?: string | null, supplierRoyaltyStatus: Types.SupplierRoyaltyStatus, unitCostText: string } | null, sourceProvenance?: { __typename?: 'MaterialPriceSourceProvenanceData', basis?: Types.MaterialPriceQuoteBasis | null, calcDecimals?: number | null, quotedAmountText?: string | null, quotedPackQuantity?: number | null, quotedUnit?: string | null, royaltyTreatment?: string | null, supplierDescription?: string | null, supplierIdentifier?: string | null } | null }> };

export type MaterialPriceHistoryValuesFragment = { __typename?: 'MaterialPriceHistoryValues', effectiveDate?: Types.TDateISO | null, isBaseRate: boolean, status: Types.MaterialPriceStatus, supplierRoyaltyPerEachText?: string | null, supplierRoyaltyStatus: Types.SupplierRoyaltyStatus, unitCostText: string };

export const MaterialPriceQuoteFragmentDoc = new TypedDocumentString(`
    fragment MaterialPriceQuote on MaterialPriceQuoteData {
  effectiveDate
  isBaseRate
  priceId
  revision
  royaltyCoverage
  status
  supplierRoyaltyPerEachText
  supplierRoyaltyStatus
  unitCostText
}
    `, {"fragmentName":"MaterialPriceQuote"});
export const MaterialApplicablePriceFragmentDoc = new TypedDocumentString(`
    fragment MaterialApplicablePrice on MaterialApplicablePriceData {
  earliestFutureEffectiveDate
  quote {
    ...MaterialPriceQuote
  }
  state
}
    fragment MaterialPriceQuote on MaterialPriceQuoteData {
  effectiveDate
  isBaseRate
  priceId
  revision
  royaltyCoverage
  status
  supplierRoyaltyPerEachText
  supplierRoyaltyStatus
  unitCostText
}`, {"fragmentName":"MaterialApplicablePrice"});
export const MaterialPriceHistoryValuesFragmentDoc = new TypedDocumentString(`
    fragment MaterialPriceHistoryValues on MaterialPriceHistoryValues {
  effectiveDate
  isBaseRate
  status
  supplierRoyaltyPerEachText
  supplierRoyaltyStatus
  unitCostText
}
    `, {"fragmentName":"MaterialPriceHistoryValues"});
export const GetMaterialPriceWriteCapabilityDocument = new TypedDocumentString(`
    query GetMaterialPriceWriteCapability {
  materialPriceWriteCapability {
    disabledReason
    enabled
    flagEnabled
    flagResolutionReason
    identityReadinessReason
    materialPriceIdentityReadReady
  }
}
    `);
export const GetMaterialPriceActionPreviewDocument = new TypedDocumentString(`
    query GetMaterialPriceActionPreview($input: MaterialPriceActionPreviewInput!) {
  materialPriceActionPreview(input: $input) {
    errors {
      code
      message
    }
    preview {
      action
      asOf
      current {
        ...MaterialApplicablePrice
      }
      estimateEffect
      explanation
      isDefaultVendor
      proposed {
        ...MaterialPriceQuote
      }
      purchasingRevision
      resulting {
        ...MaterialApplicablePrice
      }
      selected {
        ...MaterialPriceQuote
      }
      vendorId
    }
  }
}
    fragment MaterialPriceQuote on MaterialPriceQuoteData {
  effectiveDate
  isBaseRate
  priceId
  revision
  royaltyCoverage
  status
  supplierRoyaltyPerEachText
  supplierRoyaltyStatus
  unitCostText
}
fragment MaterialApplicablePrice on MaterialApplicablePriceData {
  earliestFutureEffectiveDate
  quote {
    ...MaterialPriceQuote
  }
  state
}`);
export const GetMaterialPriceHistoryDocument = new TypedDocumentString(`
    query GetMaterialPriceHistory($materialItemId: String!, $priceId: String, $vendorId: String) {
  materialPriceHistory(
    materialItemId: $materialItemId
    priceId: $priceId
    vendorId: $vendorId
  ) {
    action
    actor
    after {
      ...MaterialPriceHistoryValues
    }
    before {
      ...MaterialPriceHistoryValues
    }
    diagnostic
    eventId
    eventNumber
    occurredAt
    priceId
    reason
    revision
    sourceProvenance {
      basis
      calcDecimals
      quotedAmountText
      quotedPackQuantity
      quotedUnit
      royaltyTreatment
      supplierDescription
      supplierIdentifier
    }
    status
    vendorDetached
    vendorId
  }
}
    fragment MaterialPriceHistoryValues on MaterialPriceHistoryValues {
  effectiveDate
  isBaseRate
  status
  supplierRoyaltyPerEachText
  supplierRoyaltyStatus
  unitCostText
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetMaterialPriceWriteCapability: build.query<GetMaterialPriceWriteCapabilityQuery, GetMaterialPriceWriteCapabilityQueryVariables | void>({
      query: (variables) => ({ document: GetMaterialPriceWriteCapabilityDocument, variables })
    }),
    GetMaterialPriceActionPreview: build.query<GetMaterialPriceActionPreviewQuery, GetMaterialPriceActionPreviewQueryVariables>({
      query: (variables) => ({ document: GetMaterialPriceActionPreviewDocument, variables })
    }),
    GetMaterialPriceHistory: build.query<GetMaterialPriceHistoryQuery, GetMaterialPriceHistoryQueryVariables>({
      query: (variables) => ({ document: GetMaterialPriceHistoryDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetMaterialPriceWriteCapabilityQuery, useLazyGetMaterialPriceWriteCapabilityQuery, useGetMaterialPriceActionPreviewQuery, useLazyGetMaterialPriceActionPreviewQuery, useGetMaterialPriceHistoryQuery, useLazyGetMaterialPriceHistoryQuery } = injectedRtkApi;
